import React from 'react';
import styles from './ImageLinkControl.module.scss';
import logger from 'services/logger';
import Image from 'next/image';
import { Link } from 'components/Link';
import { defaultLoader, loaderUrl } from 'utils/cloudinary';
import { Control } from '@yleisradio/areena-types';

type Props = {
  control: Control;
  onClick?: (() => void) | undefined;
};

export const ImageLinkControl: React.FC<Props> = ({ control, onClick }) => {
  const { image, title, destination } = control;

  if (!destination) {
    logger.warn('ImageLinkControl is missing destination');
    return null;
  }

  return (
    <Link className={styles.link} onClick={onClick} pointer={destination}>
      <div className={styles.imageContainer}>
        {image ? (
          <Image
            key={image.id}
            alt={image.alt || ''}
            className={styles.image}
            style={{ objectFit: 'cover' }}
            fill
            loader={defaultLoader}
            role={image.alt ? undefined : 'presentation'}
            src={loaderUrl(image)}
          />
        ) : null}
        <h2 className={styles.title}>{title}</h2>
      </div>
    </Link>
  );
};
